import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SavedSimulationConfirmation')
export class SavedSimulationConfirmation {
  @JsonProperty('indSimValidee', Boolean, true)
  public hasBeenSaved = false;
}
